const state = {
    RouteName: ''
};

const mutations = {
    setRouteName(state, routeName) {
        const pattern = /^\/([^/]+)/;
        const match = routeName.match(pattern);
        if (match) {
            state.RouteName = match[1];
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};